export const createPriceMarkerOverlay = (position, text, onClick) => {
  class PriceMarkerOverlay extends window.woosmap.map.OverlayView {
    constructor() {
      super();
      this.position = position;
      this.text = text;
      this.onClick = onClick;
      this.containerDiv = null;
    }

    onAdd() {
      this.containerDiv = document.createElement('div');
      this.containerDiv.className = 'marker';
      this.containerDiv.style.position = 'absolute';
      this.containerDiv.style.cursor = 'pointer';
      this.containerDiv.textContent = this.text;
      this.containerDiv.addEventListener('click', this.onClick);
      this.getPanes().overlayMouseTarget.appendChild(this.containerDiv);
      if (this.isActive) this.containerDiv.classList.add('marker--active');
    }

    setActive(isActive) {
      this.isActive = isActive;
      if (!this.containerDiv) return;
      this.containerDiv.classList.toggle('marker--active', isActive);
    }

    draw() {
      if (!this.containerDiv) return;
      const projection = this.getProjection();
      if (!projection) return;
      const point = projection.fromLatLngToDivPixel(this.position);
      if (!point) return;
      const offsetW = this.containerDiv.offsetWidth / 2;
      const offsetH = this.containerDiv.offsetHeight / 2;
      this.containerDiv.style.left = `${point.x - offsetW}px`;
      this.containerDiv.style.top = `${point.y - offsetH}px`;
    }

    onRemove() {
      if (this.containerDiv?.parentNode) {
        this.containerDiv.parentNode.removeChild(this.containerDiv);
      }
      this.containerDiv = null;
    }
  }

  return new PriceMarkerOverlay();
};
